import type { AddressByZipCode } from '~/domain/Assegurou/addressByZipcode';
import apiAssegurouAuto from '../../services/apiAssegurouAuto';
import { adrressByZipcodeDTOToAdressByZipcode } from '~/mappers/Assegurou/adrressByZipcode';
import type { AddressByZipcodeResponseDTO } from '~/dto/Assegurou/addressByZipcode';

export async function getAddressByCepUseCase(
  zipCode: string
): Promise<AddressByZipCode> {
  try {
    const response = await apiAssegurouAuto.post<AddressByZipcodeResponseDTO>(
      `/consultaEndereco`,
      {
        cep: zipCode,
      }
    );

    return adrressByZipcodeDTOToAdressByZipcode(response.data);
  } catch (error) {
    return {
      success: false,
    };
  }
}
